import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_JOB } from 'src/graphql/job';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation CustomerResourceFileProcess($customerId: ID!, $resourceId: ID!) {
    customerResourceFileProcess(customerId: $customerId, resourceId: $resourceId) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

/**
 * Confirm that resource file was uploaded and BE should start processing
 *
 * @param {ID} customerId - ID of the current customer
 * @param {ID} resourceId - ID of the workspace
 * @returns {Promise<Job>} - response of the mutation
 */
export const customerResourceFileProcess = async ({ customerId, resourceId }) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, resourceId },
  });

  return getSingleProp(result.data);
};
